import { money, number, percentage } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'

interface AovCellProps {
    aov: number
    orders: number
    sales: number
}

export const AovCell = (v: AovCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)

    const lines = [
        { description: 'Sales', value: money(g('sales')) ?? '' },
        { description: '÷ Orders', value: number(g('orders')) ?? '' },
        { description: 'AOV', value: money(g('aov')) ?? '' },
    ]

    return <Calculation lines={lines}>{money(g('aov'))}</Calculation>
}

interface BlendedAovCellProps {
    blended_aov: number
    adjusted_orders: number
    blended_profit: number
}

export const BlendedAovCell = ({
    blended_aov,
    adjusted_orders,
    blended_profit,
}: BlendedAovCellProps) => {
    const lines = [
        { description: 'Blended Profit', value: money(blended_profit) ?? '' },
        { description: '÷ Adjusted Orders', value: number(adjusted_orders) ?? '' },
        { description: 'Blended AOV', value: money(blended_aov) ?? '' },
    ]

    return <Calculation lines={lines}>{money(blended_aov)}</Calculation>
}
